export default function SimpleError() {
    const target = new URLSearchParams(window.location.search).get("target");

    return (
        <div className="flex min-h-screen grow flex-col items-center justify-center gap-6 self-stretch bg-brand-beige px-6 text-center">
            <div className="text-6xl">🍓</div>
            <h1 className="text-3xl font-semibold text-brand-black">
                Something went wrong
            </h1>
            <p className="max-w-md text-brand-gray">
                We couldn&rsquo;t load that page. It may have been a connection
                hiccup.
            </p>
            <a
                href={target ?? "/"}
                className="inline-flex items-center rounded-full border border-transparent bg-brand-red px-8 py-2 font-medium text-white transition duration-150 ease-in-out hover:bg-brand-primaryButtonHover focus:bg-brand-primaryButtonHover active:bg-brand-primaryButtonClick"
            >
                Try again
            </a>
        </div>
    );
}
